import { http } from "ynf-core-middleware";

/**
 // 员工id
   private  String id;
   //员工名称
    private  String name;
    //员工用户id
    private  String yhtUserId;
    //部门id
    private  String deptId;
    //部门名称
    private  String deptName;
    //组织id
    private  String orgId;
    //组织名称
    private  String orgName;
    //上级部门Id
    private  String parentDeptId;
    //上级部门编码
    private  String parentDeptCode;
    //上级部门名称
    private String parentDeptName;
    private String parentDeptPrincipal;
    //部门负责人id
    private String deptPrincipalId;
    //部门负责人名称
    private String deptPrincipalName;
    //上级部门负责人id
    private String parentDeptPrincipalId;
    //上级部门负责人名称
    private String parentDeptPrincipalName;
    //上级上级主管id
    private String superSupervisorId;
   //上级上级主管名称
    private String superSupervisorName;
}
 * @returns res
 */
// 用户部门组件预制值请求接口
const getUserDeptInfo = async () => {
  const res = await http.get("/iuap-yonbuilder-mobile/rest/v1/mobile/addressBook/getDocumenterPrincipalInfo");
  return res;
};

export { getUserDeptInfo };